import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';

import { AssistantPresentChartComponent } from './present-chart.component';

export const providePresentChartClientTool: Provider = provideTellentAssistantRenderPresenter({
  useValue: { id: 'presentChart', component: AssistantPresentChartComponent },
});
